import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = ({ onOpenContactForm, heading, paragraph, buttonText, backgroundImage }) => {
  return (
    <section data-testid="cta-section" className="py-24 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0">
        {backgroundImage && <img src={backgroundImage} alt="" className="w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-[#0A0F1C]/85" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.2] mb-6">
            {heading}
          </h2>
          <p className="text-base md:text-lg text-gray-400 leading-relaxed mb-10">{paragraph}</p>
          <Button
            data-testid="cta-section-button"
            onClick={onOpenContactForm}
            className="bg-[#002FA7] text-white hover:bg-[#002280] font-medium px-8 py-5 rounded-none transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(0,47,167,0.4)]"
          >
            {buttonText} <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
